<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
function initChainLengthSlider() {
  const checkboxes = document.querySelectorAll('input[name="filter.p.m.custom.chain_length"]');
  if (!checkboxes.length) return;

  const filterList = checkboxes[0].closest('ul');
  if (!filterList) return;

  const filterContainer = filterList.parentElement;
  if (filterContainer.querySelector('.chain-slider-wrap')) return;

  const values = [...checkboxes]
    .map(cb => parseInt(cb.value))
    .filter(n => !isNaN(n))
    .sort((a, b) => a - b);

  if (!values.length) return;

  const min = values[0];
  const max = values[values.length - 1];

  filterList.style.display = 'none';

  const sliderHTML = `
    <style>
      .chain-slider-wrap {
        padding: 8px 4px 4px;
      }
      .chain-slider__track-wrap {
        position: relative;
        height: 28px;
        display: flex;
        align-items: center;
        margin-bottom: 14px;
      }
      .chain-slider__track {
        position: absolute;
        left: 0; right: 0;
        height: 3px;
        background: #ddd;
        border-radius: 3px;
      }
      .chain-slider__fill {
        position: absolute;
        height: 3px;
        background: #471d43;
        border-radius: 3px;
        pointer-events: none;
      }
      .chain-slider__range {
        position: absolute;
        width: 100%;
        pointer-events: none;
        -webkit-appearance: none;
        appearance: none;
        background: transparent;
        height: 3px;
        outline: none;
        margin: 0;
        padding: 0;
      }
      .chain-slider__range::-webkit-slider-thumb {
        -webkit-appearance: none !important;
        appearance: none !important;
        width: 22px !important;
        height: 22px !important;
        border-radius: 50% !important;
        background: radial-gradient(circle, #471d43 40%, #fff 40%, #fff 58%, #471d43 58%) !important;
        pointer-events: all !important;
        cursor: pointer !important;
        position: relative !important;
        z-index: 3 !important;
        box-shadow: none !important;
        border: none !important;
      }
      .chain-slider__range::-moz-range-thumb {
        width: 22px !important;
        height: 22px !important;
        border-radius: 50% !important;
        background: radial-gradient(circle, #471d43 40%, #fff 40%, #fff 58%, #471d43 58%) !important;
        pointer-events: all !important;
        cursor: pointer !important;
        border: none !important;
      }
      .chain-slider__inputs {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 14px;
      }
      .chain-slider__input-box {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 6px;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 10px 10px;
        background: #fff;
        box-sizing: border-box;
        line-height: 1;
      }
      .chain-slider__input-box .chain-label {
        color: #888;
        font-size: var(--font-body-size, 16px);
        font-family: "Source Sans Pro", sans-serif;
        font-style: normal;
        font-weight: 300;
        letter-spacing: .02em;
        white-space: nowrap;
        flex-shrink: 0;
        display: block;
        line-height: 1;
      }
      .chain-slider__input-box .chain-value {
        color: #101828;
        font-size: var(--font-body-size, 16px);
        font-family: "Source Sans Pro", sans-serif;
        font-style: normal;
        font-weight: 400;
        letter-spacing: .02em;
        display: block;
        line-height: 1;
      }
      .chain-slider__to {
        color: #555;
        font-size: var(--font-body-size, 16px);
        font-family: "Source Sans Pro", sans-serif;
        font-style: normal;
        font-weight: 300;
        letter-spacing: .02em;
        flex-shrink: 0;
        line-height: 1;
      }
      .chain-slider__apply {
        display: block;
        width: 100%;
        font-family: "Source Sans Pro", sans-serif;
        font-style: normal;
        font-weight: var(--btn-1-font-weight, 700);
        text-transform: var(--btn-1-text-transform, uppercase);
        text-align: center;
        letter-spacing: .02em;
        line-height: var(--btn-1-line-height, 1);
        text-overflow: ellipsis;
        white-space: nowrap;
        border-radius: var(--btn-1-border-radius, 40px);
        border-style: var(--btn-1-border-style, solid);
        border-width: var(--btn-1-border-width, 0);
        border-color: #471d43;
        min-width: 130px;
        max-width: 100%;
        padding: 15px;
        margin: auto;
        outline: none !important;
        cursor: pointer;
        position: relative;
        background: #471d43;
        color: #fff;
        font-size: var(--font-body-size, 16px);
        box-sizing: border-box;
        transition: opacity 0.2s;
      }
      .chain-slider__apply:hover { opacity: 0.85; }
    </style>

    <div class="chain-slider-wrap">
      <div class="chain-slider__track-wrap">
        <div class="chain-slider__track"></div>
        <div class="chain-slider__fill" id="chain-fill"></div>
        <input class="chain-slider__range" type="range" id="chain-min-range" min="${min}" max="${max}" value="${min}" step="1">
        <input class="chain-slider__range" type="range" id="chain-max-range" min="${min}" max="${max}" value="${max}" step="1">
      </div>

      <div class="chain-slider__inputs">
        <div class="chain-slider__input-box">
          <span class="chain-label">in</span>
          <span class="chain-value" id="chain-min-display">${min}</span>
        </div>
        <span class="chain-slider__to">to</span>
        <div class="chain-slider__input-box">
          <span class="chain-label">in</span>
          <span class="chain-value" id="chain-max-display">${max}</span>
        </div>
      </div>

      <button class="chain-slider__apply" id="chain-apply-btn">APPLY</button>
    </div>
  `;

  filterList.insertAdjacentHTML('afterend', sliderHTML);

  const minRange   = document.getElementById('chain-min-range');
  const maxRange   = document.getElementById('chain-max-range');
  const minDisplay = document.getElementById('chain-min-display');
  const maxDisplay = document.getElementById('chain-max-display');
  const fill       = document.getElementById('chain-fill');
  const applyBtn   = document.getElementById('chain-apply-btn');

  function updateFill() {
    const minVal = parseInt(minRange.value);
    const maxVal = parseInt(maxRange.value);
    const range  = max - min || 1;
    fill.style.left  = ((minVal - min) / range * 100) + '%';
    fill.style.right = ((max - maxVal) / range * 100) + '%';
  }

  minRange.addEventListener('input', () => {
    if (parseInt(minRange.value) > parseInt(maxRange.value)) minRange.value = maxRange.value;
    minDisplay.textContent = minRange.value;
    updateFill();
  });

  maxRange.addEventListener('input', () => {
    if (parseInt(maxRange.value) < parseInt(minRange.value)) maxRange.value = minRange.value;
    maxDisplay.textContent = maxRange.value;
    updateFill();
  });

  applyBtn.addEventListener('click', () => {
    const minVal = parseInt(minRange.value);
    const maxVal = parseInt(maxRange.value);
    checkboxes.forEach(cb => {
      const val = parseInt(cb.value);
      const inRange = val >= minVal && val <= maxVal;
      if (cb.checked !== inRange) {
        cb.checked = inRange;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  updateFill();
}

// Poll until filters appear
let attempts = 0;
const interval = setInterval(() => {
  attempts++;
  if (document.querySelectorAll('input[name="filter.p.m.custom.chain_length"]').length) {
    initChainLengthSlider();
    clearInterval(interval);
  }
  if (attempts > 20) clearInterval(interval);
}, 500);

// Re-run after Ella AJAX filter updates
document.addEventListener('click', function(e) {
  if (e.target.closest('.facets__form, [data-facets]')) {
    setTimeout(initChainLengthSlider, 600);
  }
});